/**
サーバーと通信するためのjs
*/
'use strict';

function requestServer(url, type, data, callback, option = null) {
  let send_params = {
    url:      url,
    type:     type,
    data:     data,
    headers:  {
      'Authorization': `Token token=${obs.token}`,
      'Accept' : 'application/json'
    },
    dataType: 'json',
  }

  if(option) {
    if(option.array) {
      send_params.contentType = 'application/json'
      send_params.data        = JSON.stringify(data) // データをjsonにし直す
    }
  }

  $.ajax(send_params).done((response) => {
    callback(response)
  }).fail((response) => {
    passiveLoading()
    error('通信に失敗しました', response)
  })
}
window.requestServer = requestServer

// Promise化
function requestServerByPromise(url, type, data, option = null) {
  return new Promise((resolve, reject) => {
    let send_params = {
      url:         url,
      type:        type,
      data:        data,
      headers:  {
        'Authorization': `Token token=${obs.token}`,
        'Accept' : 'application/json'
      },
      dataType: 'json',
    }

    if(type == "POST") {
      //send_params.processData = false
    }

    if(option) {
      if(option.array) {
        send_params.contentType = 'application/json'
        send_params.data        = JSON.stringify(data) // データをjsonにし直す
      }
    }

    $.ajax(send_params).done((response) => {
      resolve(response)
    }).fail((response) => {
      console.warn(response)
      passiveLoading()
      if(response.responseJSON && response.responseJSON.message) {
        reject(response.responseJSON)
      } else {
        reject('通信に失敗しました', response)
      }
    })
  })
}
window.requestServerByPromise = requestServerByPromise

// 音源を送信するときのメソッド
function requestServerWithFile(url, method, data, progressCallback) {
  return new Promise((resolve, reject) => {
    let send_params = {
      url:         url,
      async:       true,
      method:      method,
      data:        data,
      contentType: false,
      processData: false,
      xhr: () => {
        let XHR = $.ajaxSettings.xhr()
        if(XHR.upload) {
          XHR.upload.addEventListener('progress',function(e){
            progressCallback(parseInt(e.loaded/e.total*100))
          }, false);
        }
        return XHR
      },
      headers:  {
        'Authorization': `Token token=${obs.token}`,
      }
    }
    $.ajax(send_params).done((response) => {
      resolve(response)
      //if (completeCallback) completeCallback(response)
    }).fail((response) => {
      passiveLoading()
      console.warn("fail!!!!!!!")
      console.warn(response)
      reject(response)
      //error('通信に失敗しました', response)
    })
  })
}
window.requestServerWithFile = requestServerWithFile

// BeatfitNodeとの通信
function requestNodeServer(url, type, data, option = null) {
  return new Promise((resolve, reject) => {
    let node_url = (window.env === "beatfit-dev") ?
                   `https://dev-beatfit-node.herokuapp.com${url}` :
                   `https://prod-beatfit-node.herokuapp.com${url}`;
    let send_params = {
      url:      node_url,
      type:     type,
      data:     data,
      headers:  {
        'Accept' : 'application/json'
      },
      dataType: 'json',
    }

    if(option) {
      if(option.array) {
        send_params.contentType = 'application/json'
        send_params.data        = JSON.stringify(data) // データをjsonにし直す
      }
    }

    $.ajax(send_params).done((response) => {
      resolve(response)
    }).fail((response) => {
      console.warn(response.message)
      passiveLoading()
      reject('通信に失敗しました', response)
    })
  })
}
window.requestNodeServer = requestNodeServer
